import React, { useEffect, useRef } from 'react'
import Script from 'next/script'
import { useCookieConsent } from '../../hooks/useCookieConsent'
import GoogleAnalytics from './GoogleAnalytics'

declare global {
  interface Window {
    _uxa?: Array<[string, ...unknown[]]>
  }
}

function useContentsquareConsent(ready: boolean, analyticsAllowed: boolean) {
  const wasAllowed = useRef(false)

  useEffect(() => {
    if (!ready) return

    if (analyticsAllowed) {
      wasAllowed.current = true
    } else if (wasAllowed.current) {
      window._uxa = window._uxa || []
      window._uxa.push(['optout'])
      wasAllowed.current = false
    }
  }, [ready, analyticsAllowed])
}

export const AnalyticsScripts: React.FC = () => {
  const { ready, analyticsAllowed } = useCookieConsent()

  useContentsquareConsent(ready, analyticsAllowed)

  if (!ready || !analyticsAllowed) return null

  return (
    <>
      {process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID && (
        <GoogleAnalytics measurementId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID} />
      )}
      <Script
        src="https://analytics.ahrefs.com/analytics.js"
        data-key="vlv1d00dEGjyfBk7mOsGzA"
        strategy="afterInteractive"
      />
      <Script src="https://t.contentsquare.net/uxa/32277e84b975f.js" strategy="afterInteractive" />
    </>
  )
}
